<div fxLayout="column" fxLayoutAlign="start stretch" class="layout-wrapper">
  <div class="container">
    <app-main-container></app-main-container>
  </div>
</div>
